import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Card } from 'react-bootstrap'
import { updateSimulacionExportador } from '../actions'
import AppBar from '@material-ui/core/AppBar'
import { Tabs, Tab } from '@material-ui/core'
import { reduxForm } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../config/forms'
import EstimacionSemanalCereal from './EstimacionSemanalCereal'
import PanelConfiguracionEstimacion from '../components/estimacionStock/PanelConfiguracionEstimacion'
import SimulacionProyeccionExportador from './SimulacionProyeccionExportador'
import DetalleBuquesPorDia from '../../Buque/components/anunciobuques/DetalleBuquesPorDia'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../config/settings'

function TabPanel (props) {
  const { children, value, index } = props

  const hiddenStyle = {
    textAlign: 'justify',
    margin: '0 2%',
    display: value === index ? 'block' : 'none'
  }

  return (
    <div role='tabpanel' id={index} key={index} style={hiddenStyle}>
      {children}
    </div>
  )
}

function SimulacionProyeccion (props) {
  const { change: formChange, updateSimulacionExportador } = props
  const [time, setTime] = useState(8)
  const [value, setValue] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      if (time > 0) {
        setTime(time - 1)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [time])

  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (newValue === 0) {
      formChange('simulacionActiva', undefined)
      updateSimulacionExportador(false)
    }
    if (newValue === 1) {
      updateSimulacionExportador(true)
    }
  }

  const OPTIONS = [
    {
      tabLabel: 'Proyección por cereal',
      contenido: <EstimacionSemanalCereal simulacion />
    },
    {
      tabLabel: 'Proyección por exportador',
      contenido: <SimulacionProyeccionExportador />
    }
  ]

  const renderLabel = () => {
    return OPTIONS.map((d, index) => {
      return (
        <Tab key={index} label={d.tabLabel} style={{ outline: 'none' }} />
      )
    })
  }

  const renderSimulacion = () => {
    return OPTIONS.map((d, index) => {
      return (
        <TabPanel
          value={value}
          index={index}
          key={index}
          style={{ marginBottom: 0, overFlow: 'scroll' }}
        >
          {d.contenido}
        </TabPanel>
      )
    })
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Row style={{ margin: '-3.5% 1% 0 0' }}>
        <Col md={9} style={{ zIndex: '10' }}>
          <Card
            className='shadow bg-white'
            style={{ borderRadius: '22px' }}
          >
            <AppBar
              position='static'
              color='default'
              key={'appbar'}

            >
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor='primary'
                variant='scrollable'
                scrollButtons='desktop'
                style={{ margin: '0 !important' }}
              >
                {renderLabel()}
              </Tabs>
            </AppBar>
            {renderSimulacion()}
          </Card>
        </Col>
        <Col
          md={3}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start'
          }}
        >
          {time === 0 &&
            <PanelConfiguracionEstimacion
              pesoCamion={props.pesoCamion}
              cumplimiento={props.cumplimiento}
              tipoSimulacion={value}
            />
          }
        </Col>

        {value === 0 &&
          <Col md={3}
            style={{
              padding: '18px',
              borderRadius: '28px',
              position: 'fixed',
              bottom: '1%',
              right: '2%',
              minWidth: '25vh'
            }}
          >
            <DetalleBuquesPorDia />

          </Col>
        }
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  pesoCamion: state.camionesIngreso.promedioPesoCamion,
  cumplimiento: state.cupos.cumplimientoCupo,
  isSimulacionExportador: state.stock.isSimulacionExportador
})

const mapActionsToProps = {
  updateSimulacionExportador
}

const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false,
  initialValues: {
    exportadoresSimulacion: [],
    simulacionActiva: undefined
  }
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(SimulacionProyeccion))
